/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Guide_Syntax_ErrorsInputs */

const en_sidebar_guide_syntax_errors = /** @type {(inputs: Sidebar_Guide_Syntax_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syntax Errors`)
};

const ko_sidebar_guide_syntax_errors = /** @type {(inputs: Sidebar_Guide_Syntax_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구문 오류`)
};

const ja_sidebar_guide_syntax_errors = /** @type {(inputs: Sidebar_Guide_Syntax_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`構文エラー`)
};

/**
* | output |
* | --- |
* | "Syntax Errors" |
*
* @param {Sidebar_Guide_Syntax_ErrorsInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_guide_syntax_errors = /** @type {((inputs?: Sidebar_Guide_Syntax_ErrorsInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Guide_Syntax_ErrorsInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_guide_syntax_errors(inputs)
	if (locale === "ko") return ko_sidebar_guide_syntax_errors(inputs)
	return ja_sidebar_guide_syntax_errors(inputs)
});